import { render, staticRenderFns } from "./PetOwnerRegisterSocial.vue?vue&type=template&id=76a54393&scoped=true&"
import script from "./PetOwnerRegisterSocial.vue?vue&type=script&lang=js&"
export * from "./PetOwnerRegisterSocial.vue?vue&type=script&lang=js&"
import style0 from "./PetOwnerRegisterSocial.vue?vue&type=style&index=0&id=76a54393&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a54393",
  null
  
)

export default component.exports